import React, { useState } from 'react';
import HTMLReactParser from 'html-react-parser';
import { useParams } from 'react-router-dom';
import millify from 'millify';
import { Col, Row, Typography, Select } from 'antd';
import { MoneyCollectOutlined, DollarCircleOutlined, FundOutlined, ExclamationCircleOutlined, StopOutlined, TrophyOutlined, CheckOutlined, NumberOutlined, ThunderboltOutlined } from '@ant-design/icons';

import { useGetCryptoDetailsQuery, useGetCryptoHistoryQuery } from './sevices/cryptoApi';
import Loader from './Loader';
import LineChart from './Linechart'

const { Title, Text } = Typography;
const { Option } = Select;

const CryptoDetails = () => {
  const { coinId } = useParams();
  const [timeperiod, setTimeperiod] = useState('7d');
  const { data, isFetching } = useGetCryptoDetailsQuery(coinId);
  // const {  data:coinHistor y } = useGetCryptoHistoryQuery({ coinId, timeperiod });
  const coinHistory= {
    "status": "success",
    "data": {
        "change": "0.85",
        "history": [
            {
                "price": "36708.65416670636",
                "timestamp": 1643151300
            },
            {
                "price": "36675.60530594042",
                "timestamp": 1643151000
            },
            {
                "price": "36668.76599651973",
                "timestamp": 1643150700
            },
            {
                "price": "36688.945762089694",
                "timestamp": 1643150400
            },
            {
                "price": "36603.04461521345",
                "timestamp": 1643150100
            },
            {
                "price": "36596.62901740375",
                "timestamp": 1643149800
            },
            {
                "price": "36554.15661585262",
                "timestamp": 1643149500
            },
            {
                "price": "36616.1373565284",
                "timestamp": 1643149200
            },
            {
                "price": "36659.97358919763",
                "timestamp": 1643148900
            },
            {
                "price": "36667.13887277139",
                "timestamp": 1643148600
            },
            {
                "price": "36655.78095519995",
                "timestamp": 1643148300
            },
            {
                "price": "36632.51436997895",
                "timestamp": 1643148000
            },
            {
                "price": "36567.756685500106",
                "timestamp": 1643147700
            },
            {
                "price": "36598.94858124742",
                "timestamp": 1643147400
            },
            {
                "price": "36584.15551082519",
                "timestamp": 1643147100
            },
            {
                "price": "36568.8847668982",
                "timestamp": 1643146800
            },
            {
                "price": "36602.1358917803",
                "timestamp": 1643146500
            },
            {
                "price": "36600.25443927502",
                "timestamp": 1643146200
            },
            {
                "price": "36668.34329567708",
                "timestamp": 1643145900
            },
            {
                "price": "36718.962951156944",
                "timestamp": 1643145600
            },
            {
                "price": "36746.563734023104",
                "timestamp": 1643145300
            },
            {
                "price": "36737.08402487341",
                "timestamp": 1643145000
            },
            {
                "price": "36843.26519945035",
                "timestamp": 1643144700
            },
            {
                "price": "36914.75883646812",
                "timestamp": 1643144400
            },
            {
                "price": "36929.19460916116",
                "timestamp": 1643144100
            },
            {
                "price": "37004.69392989987",
                "timestamp": 1643143800
            },
            {
                "price": "37013.3303982127",
                "timestamp": 1643143500
            },
            {
                "price": "36822.569022210824",
                "timestamp": 1643143200
            },
            {
                "price": "36757.92006345457",
                "timestamp": 1643142900
            },
            {
                "price": "36875.47522423599",
                "timestamp": 1643142600
            },
            {
                "price": "36930.808787394766",
                "timestamp": 1643142300
            },
            {
                "price": "36941.109274044466",
                "timestamp": 1643142000
            },
            {
                "price": "36907.32427239225",
                "timestamp": 1643141700
            },
            {
                "price": "36943.64353500815",
                "timestamp": 1643141400
            },
            {
                "price": "37043.11447780419",
                "timestamp": 1643141100
            },
            {
                "price": "37186.30846398933",
                "timestamp": 1643140800
            },
            {
                "price": "37191.572626152236",
                "timestamp": 1643140500
            },
            {
                "price": "37243.485237746354",
                "timestamp": 1643140200
            },
            {
                "price": "37177.81688814794",
                "timestamp": 1643139900
            },
            {
                "price": "37028.76632922441",
                "timestamp": 1643139600
            },
            {
                "price": "37148.44637589399",
                "timestamp": 1643139300
            },
            {
                "price": "37239.8373999363",
                "timestamp": 1643139000
            },
            {
                "price": "37354.6756146352",
                "timestamp": 1643138700
            },
            {
                "price": "37389.90306146463",
                "timestamp": 1643138400
            },
            {
                "price": "37298.95602708211",
                "timestamp": 1643138100
            },
            {
                "price": "37223.77338452285",
                "timestamp": 1643137800
            },
            {
                "price": "37277.44724910055",
                "timestamp": 1643137500
            },
            {
                "price": "37336.083086812185",
                "timestamp": 1643137200
            },
            {
                "price": "37379.34329239348",
                "timestamp": 1643136900
            },
            {
                "price": "37339.3809303856",
                "timestamp": 1643136600
            },
            {
                "price": "37345.92362002501",
                "timestamp": 1643136300
            },
            {
                "price": "37410.78371731544",
                "timestamp": 1643136000
            },
            {
                "price": "37444.305682423525",
                "timestamp": 1643135700
            },
            {
                "price": "37459.67967045895",
                "timestamp": 1643135400
            },
            {
                "price": "37334.80500985785",
                "timestamp": 1643135100
            },
            {
                "price": "37325.35555109142",
                "timestamp": 1643134800
            },
            {
                "price": "37250.8204812683",
                "timestamp": 1643134500
            },
            {
                "price": "37190.56339790678",
                "timestamp": 1643134200
            },
            {
                "price": "37208.86433838702",
                "timestamp": 1643133900
            },
            {
                "price": "37159.406837428665",
                "timestamp": 1643133600
            },
            {
                "price": "37206.136735085405",
                "timestamp": 1643133300
            },
            {
                "price": "37274.28088990582",
                "timestamp": 1643133000
            },
            {
                "price": "37241.19602759859",
                "timestamp": 1643132700
            },
            {
                "price": "37215.11140051253",
                "timestamp": 1643132400
            },
            {
                "price": "37222.37944315018",
                "timestamp": 1643132100
            },
            {
                "price": "37318.48387987605",
                "timestamp": 1643131800
            },
            {
                "price": "37367.72940904519",
                "timestamp": 1643131500
            },
            {
                "price": "37171.65407400051",
                "timestamp": 1643131200
            },
            {
                "price": "37081.9855662342",
                "timestamp": 1643130900
            },
            {
                "price": "37117.272743725705",
                "timestamp": 1643130600
            },
            {
                "price": "36917.647409141704",
                "timestamp": 1643130300
            },
            {
                "price": "36928.45543994977",
                "timestamp": 1643130000
            },
            {
                "price": "36997.88433208301",
                "timestamp": 1643129700
            },
            {
                "price": "36953.629479449446",
                "timestamp": 1643129400
            },
            {
                "price": "36794.2057245273",
                "timestamp": 1643129100
            },
            {
                "price": "36738.9824786558",
                "timestamp": 1643128800
            },
            {
                "price": "36799.000904939254",
                "timestamp": 1643128500
            },
            {
                "price": "36816.68855615674",
                "timestamp": 1643128200
            },
            {
                "price": "36872.68096999732",
                "timestamp": 1643127900
            },
            {
                "price": "36748.86851137251",
                "timestamp": 1643127600
            },
            {
                "price": "36653.98108994552",
                "timestamp": 1643127300
            },
            {
                "price": "36626.07831668392",
                "timestamp": 1643127000
            },
            {
                "price": "36615.85576982887",
                "timestamp": 1643126700
            },
            {
                "price": "36618.75789260953",
                "timestamp": 1643126400
            },
            {
                "price": "36705.464358326506",
                "timestamp": 1643126100
            },
            {
                "price": "36725.723462562826",
                "timestamp": 1643125800
            },
            {
                "price": "36551.2181906067",
                "timestamp": 1643125500
            },
            {
                "price": "36509.69213558358",
                "timestamp": 1643125200
            },
            {
                "price": "36601.09178945033",
                "timestamp": 1643124900
            },
            {
                "price": "36580.55867680528",
                "timestamp": 1643124600
            },
            {
                "price": "36389.691083432976",
                "timestamp": 1643124300
            },
            {
                "price": "36480.42639856022",
                "timestamp": 1643124000
            },
            {
                "price": "36323.48645348402",
                "timestamp": 1643123700
            },
            {
                "price": "36203.519685088024",
                "timestamp": 1643123400
            },
            {
                "price": "36212.77259856044",
                "timestamp": 1643123100
            },
            {
                "price": "36374.53886946102",
                "timestamp": 1643122800
            },
            {
                "price": "36466.978814514034",
                "timestamp": 1643122500
            },
            {
                "price": "36664.91109270661",
                "timestamp": 1643122200
            },
            {
                "price": "36850.389920757916",
                "timestamp": 1643121900
            },
            {
                "price": "36923.14323565977",
                "timestamp": 1643121600
            },
            {
                "price": "36601.094547196226",
                "timestamp": 1643121300
            },
            {
                "price": "36663.49653256936",
                "timestamp": 1643121000
            },
            {
                "price": "36764.946486275796",
                "timestamp": 1643120700
            },
            {
                "price": "36680.61704002807",
                "timestamp": 1643120400
            },
            {
                "price": "36597.52117102403",
                "timestamp": 1643120100
            },
            {
                "price": "36568.35181791739",
                "timestamp": 1643119800
            },
            {
                "price": "36462.259535505815",
                "timestamp": 1643119500
            },
            {
                "price": "36481.141603536664",
                "timestamp": 1643119200
            },
            {
                "price": "36409.921606636606",
                "timestamp": 1643118900
            },
            {
                "price": "36457.70845986767",
                "timestamp": 1643118600
            },
            {
                "price": "36407.165136680116",
                "timestamp": 1643118300
            },
            {
                "price": "36418.201360910956",
                "timestamp": 1643118000
            },
            {
                "price": "36369.72420137409",
                "timestamp": 1643117700
            },
            {
                "price": "36358.616012698054",
                "timestamp": 1643117400
            },
            {
                "price": "36476.02212036162",
                "timestamp": 1643117100
            },
            {
                "price": "36462.325556412026",
                "timestamp": 1643116800
            },
            {
                "price": "36407.83839070923",
                "timestamp": 1643116500
            },
            {
                "price": "36453.503220487604",
                "timestamp": 1643116200
            },
            {
                "price": "36557.87046116337",
                "timestamp": 1643115900
            },
            {
                "price": "36543.60936873139",
                "timestamp": 1643115600
            },
            {
                "price": "36558.71708824566",
                "timestamp": 1643115300
            },
            {
                "price": "36622.14316907506",
                "timestamp": 1643115000
            },
            {
                "price": "36648.231758910435",
                "timestamp": 1643114700
            },
            {
                "price": "36531.078466769206",
                "timestamp": 1643114400
            },
            {
                "price": "36494.24860314251",
                "timestamp": 1643114100
            },
            {
                "price": "36462.644506897974",
                "timestamp": 1643113800
            },
            {
                "price": "36429.941961826364",
                "timestamp": 1643113500
            },
            {
                "price": "36332.47655316486",
                "timestamp": 1643113200
            },
            {
                "price": "36333.56550766437",
                "timestamp": 1643112900
            },
            {
                "price": "36329.59194583943",
                "timestamp": 1643112600
            },
            {
                "price": "36422.30874858413",
                "timestamp": 1643112300
            },
            {
                "price": "36438.13949217377",
                "timestamp": 1643112000
            },
            {
                "price": "36425.30307650375",
                "timestamp": 1643111700
            },
            {
                "price": "36417.59321364551",
                "timestamp": 1643111400
            },
            {
                "price": "36330.23480187922",
                "timestamp": 1643111100
            },
            {
                "price": "36389.19041670526",
                "timestamp": 1643110800
            },
            {
                "price": "36322.62065322616",
                "timestamp": 1643110500
            },
            {
                "price": "36325.0297760091",
                "timestamp": 1643110200
            },
            {
                "price": "36410.90159676793",
                "timestamp": 1643109900
            },
            {
                "price": "36519.59444612938",
                "timestamp": 1643109600
            },
            {
                "price": "36549.514276503396",
                "timestamp": 1643109300
            },
            {
                "price": "36550.77612943209",
                "timestamp": 1643109000
            },
            {
                "price": "36483.57218276864",
                "timestamp": 1643108700
            },
            {
                "price": "36445.18394888157",
                "timestamp": 1643108400
            },
            {
                "price": "36422.76123955544",
                "timestamp": 1643108100
            },
            {
                "price": "36391.747633826104",
                "timestamp": 1643107800
            },
            {
                "price": "36390.60704376741",
                "timestamp": 1643107500
            },
            {
                "price": "36393.112102954925",
                "timestamp": 1643107200
            },
            {
                "price": "36484.382082600794",
                "timestamp": 1643106900
            },
            {
                "price": "36507.022067209284",
                "timestamp": 1643106600
            },
            {
                "price": "36543.54714780193",
                "timestamp": 1643106300
            },
            {
                "price": "36624.0740230468",
                "timestamp": 1643106000
            },
            {
                "price": "36576.26468132999",
                "timestamp": 1643105700
            },
            {
                "price": "36441.235033098856",
                "timestamp": 1643105400
            },
            {
                "price": "36412.38131306528",
                "timestamp": 1643105100
            },
            {
                "price": "36482.81319212757",
                "timestamp": 1643104800
            },
            {
                "price": "36408.83168724803",
                "timestamp": 1643104500
            },
            {
                "price": "36365.82356527705",
                "timestamp": 1643104200
            },
            {
                "price": "36345.933851057154",
                "timestamp": 1643103900
            },
            {
                "price": "36398.949396046235",
                "timestamp": 1643103600
            },
            {
                "price": "36385.29031156613",
                "timestamp": 1643103300
            },
            {
                "price": "36380.49544680652",
                "timestamp": 1643103000
            },
            {
                "price": "36285.28528900131",
                "timestamp": 1643102700
            },
            {
                "price": "36230.08443781593",
                "timestamp": 1643102400
            },
            {
                "price": "36224.98953325415",
                "timestamp": 1643102100
            },
            {
                "price": "36211.073630379564",
                "timestamp": 1643101800
            },
            {
                "price": "36099.743476890275",
                "timestamp": 1643101500
            },
            {
                "price": "36148.65557744592",
                "timestamp": 1643101200
            },
            {
                "price": "36264.97341582833",
                "timestamp": 1643100900
            },
            {
                "price": "36224.009073393616",
                "timestamp": 1643100600
            },
            {
                "price": "36206.2275449735",
                "timestamp": 1643100300
            },
            {
                "price": "36121.23405111956",
                "timestamp": 1643100000
            },
            {
                "price": "36099.147173899255",
                "timestamp": 1643099700
            },
            {
                "price": "36225.22642779237",
                "timestamp": 1643099400
            },
            {
                "price": "36383.77777126689",
                "timestamp": 1643099100
            },
            {
                "price": "36391.839847143085",
                "timestamp": 1643098800
            },
            {
                "price": "36202.440914519844",
                "timestamp": 1643098500
            },
            {
                "price": "36152.26028912337",
                "timestamp": 1643098200
            },
            {
                "price": "36157.90641669506",
                "timestamp": 1643097900
            },
            {
                "price": "36056.51309113383",
                "timestamp": 1643097600
            },
            {
                "price": "36039.63181215101",
                "timestamp": 1643097300
            },
            {
                "price": "36025.802269731146",
                "timestamp": 1643097000
            },
            {
                "price": "36042.25202594727",
                "timestamp": 1643096700
            },
            {
                "price": "36012.92555016179",
                "timestamp": 1643096400
            },
            {
                "price": "35982.212843968315",
                "timestamp": 1643096100
            },
            {
                "price": "35866.65776108026",
                "timestamp": 1643095800
            },
            {
                "price": "35802.124036635185",
                "timestamp": 1643095500
            },
            {
                "price": "35748.44734424362",
                "timestamp": 1643095200
            },
            {
                "price": "35754.79362392991",
                "timestamp": 1643094900
            },
            {
                "price": "35843.680733557456",
                "timestamp": 1643094600
            },
            {
                "price": "35895.96217386656",
                "timestamp": 1643094300
            },
            {
                "price": "35898.28835771406",
                "timestamp": 1643094000
            },
            {
                "price": "35940.43364861174",
                "timestamp": 1643093700
            },
            {
                "price": "35940.03326031184",
                "timestamp": 1643093400
            },
            {
                "price": "35966.459437168785",
                "timestamp": 1643093100
            },
            {
                "price": "36054.312713708816",
                "timestamp": 1643092800
            },
            {
                "price": "35991.87623853247",
                "timestamp": 1643092500
            },
            {
                "price": "35984.536314301506",
                "timestamp": 1643092200
            },
            {
                "price": "36007.631661627216",
                "timestamp": 1643091900
            },
            {
                "price": "36039.13254674212",
                "timestamp": 1643091600
            },
            {
                "price": "36049.543201053166",
                "timestamp": 1643091300
            },
            {
                "price": "36090.93591349397",
                "timestamp": 1643091000
            },
            {
                "price": "36066.45378277984",
                "timestamp": 1643090700
            },
            {
                "price": "36063.99383436946",
                "timestamp": 1643090400
            },
            {
                "price": "36024.85788326693",
                "timestamp": 1643090100
            },
            {
                "price": "36007.42817672935",
                "timestamp": 1643089800
            },
            {
                "price": "36014.522390884915",
                "timestamp": 1643089500
            },
            {
                "price": "35944.81895708257",
                "timestamp": 1643089200
            },
            {
                "price": "35929.03236149008",
                "timestamp": 1643088900
            },
            {
                "price": "35907.22746495699",
                "timestamp": 1643088600
            },
            {
                "price": "35946.735900881235",
                "timestamp": 1643088300
            },
            {
                "price": "36023.29813600713",
                "timestamp": 1643088000
            },
            {
                "price": "36089.69921482046",
                "timestamp": 1643087700
            },
            {
                "price": "36092.695133536145",
                "timestamp": 1643087400
            },
            {
                "price": "35991.634969747734",
                "timestamp": 1643087100
            },
            {
                "price": "35986.418933537505",
                "timestamp": 1643086800
            },
            {
                "price": "36018.884621428",
                "timestamp": 1643086500
            },
            {
                "price": "36117.08686639009",
                "timestamp": 1643086200
            },
            {
                "price": "36209.53593772978",
                "timestamp": 1643085900
            },
            {
                "price": "36222.29273193754",
                "timestamp": 1643085600
            },
            {
                "price": "36376.79679992724",
                "timestamp": 1643085300
            },
            {
                "price": "36404.512597641595",
                "timestamp": 1643085000
            },
            {
                "price": "36367.16437091351",
                "timestamp": 1643084700
            },
            {
                "price": "36353.20201509478",
                "timestamp": 1643084400
            },
            {
                "price": "36387.36493863961",
                "timestamp": 1643084100
            },
            {
                "price": "36402.10356098222",
                "timestamp": 1643083800
            },
            {
                "price": "36438.92205968015",
                "timestamp": 1643083500
            },
            {
                "price": "36415.501849593944",
                "timestamp": 1643083200
            },
            {
                "price": "36371.2950998205",
                "timestamp": 1643082900
            },
            {
                "price": "36307.802173564014",
                "timestamp": 1643082600
            },
            {
                "price": "36345.43940743342",
                "timestamp": 1643082300
            },
            {
                "price": "36350.85282003177",
                "timestamp": 1643082000
            },
            {
                "price": "36355.813726175744",
                "timestamp": 1643081700
            },
            {
                "price": "36244.79667646462",
                "timestamp": 1643081400
            },
            {
                "price": "36224.59890991882",
                "timestamp": 1643081100
            },
            {
                "price": "36226.62644307001",
                "timestamp": 1643080800
            },
            {
                "price": "36211.49723146279",
                "timestamp": 1643080500
            },
            {
                "price": "36235.290312560646",
                "timestamp": 1643080200
            },
            {
                "price": "36259.41880393646",
                "timestamp": 1643079900
            },
            {
                "price": "36319.78129638977",
                "timestamp": 1643079600
            },
            {
                "price": "36302.85847479666",
                "timestamp": 1643079300
            },
            {
                "price": "36240.55547465188",
                "timestamp": 1643079000
            },
            {
                "price": "36189.31165517485",
                "timestamp": 1643078700
            },
            {
                "price": "36168.35059362965",
                "timestamp": 1643078400
            },
            {
                "price": "36205.17575082741",
                "timestamp": 1643078100
            },
            {
                "price": "36174.31784140129",
                "timestamp": 1643077800
            },
            {
                "price": "36152.535653025545",
                "timestamp": 1643077500
            },
            {
                "price": "36178.59577897812",
                "timestamp": 1643077200
            },
            {
                "price": "36219.22541406974",
                "timestamp": 1643076900
            },
            {
                "price": "36193.88959341147",
                "timestamp": 1643076600
            },
            {
                "price": "36149.093735978946",
                "timestamp": 1643076300
            },
            {
                "price": "36120.52710870602",
                "timestamp": 1643076000
            },
            {
                "price": "36142.56245014558",
                "timestamp": 1643075700
            },
            {
                "price": "36113.04782766081",
                "timestamp": 1643075400
            },
            {
                "price": "36069.98193246297",
                "timestamp": 1643075100
            },
            {
                "price": "36135.57034840338",
                "timestamp": 1643074800
            },
            {
                "price": "36153.10897239598",
                "timestamp": 1643074500
            },
            {
                "price": "36162.195251741025",
                "timestamp": 1643074200
            },
            {
                "price": "36123.674760047325",
                "timestamp": 1643073900
            },
            {
                "price": "36057.55679777624",
                "timestamp": 1643073600
            },
            {
                "price": "36080.97323205859",
                "timestamp": 1643073300
            },
            {
                "price": "36170.336890115905",
                "timestamp": 1643073000
            },
            {
                "price": "36125.89303019471",
                "timestamp": 1643072700
            },
            {
                "price": "36079.577388515216",
                "timestamp": 1643072400
            },
            {
                "price": "36164.732418681095",
                "timestamp": 1643072100
            },
            {
                "price": "36264.278296426644",
                "timestamp": 1643071800
            },
            {
                "price": "36335.98870399394",
                "timestamp": 1643071500
            },
            {
                "price": "36338.58450208615",
                "timestamp": 1643071200
            },
            {
                "price": "36342.8271951508",
                "timestamp": 1643070900
            },
            {
                "price": "36418.41393533868",
                "timestamp": 1643070600
            },
            {
                "price": "36531.67816644721",
                "timestamp": 1643070300
            },
            {
                "price": "36598.46142701887",
                "timestamp": 1643070000
            },
            {
                "price": "36475.0354941111",
                "timestamp": 1643069700
            },
            {
                "price": "36529.183152903046",
                "timestamp": 1643069400
            },
            {
                "price": "36608.11867867682",
                "timestamp": 1643069100
            },
            {
                "price": "36650.97549235741",
                "timestamp": 1643068800
            },
            {
                "price": "36669.6954113837",
                "timestamp": 1643068500
            },
            {
                "price": "36707.63669863819",
                "timestamp": 1643068200
            },
            {
                "price": "36684.25105466396",
                "timestamp": 1643067900
            },
            {
                "price": "36647.429181985724",
                "timestamp": 1643067600
            },
            {
                "price": "36577.49718233774",
                "timestamp": 1643067300
            },
            {
                "price": "36550.1922000978",
                "timestamp": 1643067000
            },
            {
                "price": "36594.91878073949",
                "timestamp": 1643066700
            },
            {
                "price": "36615.707114591154",
                "timestamp": 1643066400
            },
            {
                "price": "36518.763175787644",
                "timestamp": 1643066100
            },
            {
                "price": "36459.03600155245",
                "timestamp": 1643065800
            },
            {
                "price": "36429.2169306876",
                "timestamp": 1643065500
            },
            {
                "price": "36381.83541073311",
                "timestamp": 1643065200
            }
        ]
    }
}
  const cryptoDetails = data?.data?.coin;

  if (isFetching) return <Loader />;

  const time = ['3h', '24h', '7d', '30d', '1y', '3m', '3y', '5y'];

  const stats = [
    { title: 'Price to USD', value: `$ ${cryptoDetails?.price && millify(cryptoDetails?.price)}`, icon: <DollarCircleOutlined /> },
    { title: 'Rank', value: cryptoDetails?.rank, icon: <NumberOutlined /> },
    { title: '24h Volume', value: `$ ${cryptoDetails?.volume && millify(cryptoDetails?.volume)}`, icon: <ThunderboltOutlined /> },
    { title: 'Market Cap', value: `$ ${cryptoDetails?.marketCap && millify(cryptoDetails?.marketCap)}`, icon: <DollarCircleOutlined /> },
    { title: 'All-time-high(daily avg.)', value: `$ ${cryptoDetails?.allTimeHigh?.price && millify(cryptoDetails?.allTimeHigh?.price)}`, icon: <TrophyOutlined /> },
  ];

  const genericStats = [
    { title: 'Number Of Markets', value: cryptoDetails?.numberOfMarkets, icon: <FundOutlined /> },
    { title: 'Number Of Exchanges', value: cryptoDetails?.numberOfExchanges, icon: <MoneyCollectOutlined /> },
    { title: 'Aprroved Supply', value: cryptoDetails?.supply?.confirmed ? <CheckOutlined /> : <StopOutlined />, icon: <ExclamationCircleOutlined /> },
    { title: 'Total Supply', value: `$ ${cryptoDetails?.supply?.total && millify(cryptoDetails?.supply?.total)}`, icon: <ExclamationCircleOutlined /> },
    { title: 'Circulating Supply', value: `$ ${cryptoDetails?.supply?.circulating && millify(cryptoDetails?.supply?.circulating)}`, icon: <ExclamationCircleOutlined /> },
  ];

  return (

    <Col className="coin-detail-container">
      <Col className="coin-heading-container">
        <Title level={2} className="coin-name">
          {data?.data?.coin.name} ({data?.data?.coin.symbol}) Price
        </Title>
        <p>{cryptoDetails.name} live price in US Dollar (USD). View value statistics, market cap and supply.</p>
      </Col>

      <Select defaultValue="7d" className="select-timeperiod" placeholder="Select Timeperiod" onChange={(value) => setTimeperiod(value)}>
        {time.map((date) => <Option key={date}>{date}</Option>)}
      </Select>
      <LineChart coinHistory={coinHistory} currentPrice={millify(cryptoDetails?.price)} coinName={cryptoDetails?.name} />
      <Col className="stats-container">
        <Col className="coin-value-statistics">
          <Col className="coin-value-statistics-heading">
            <Title level={3} className="coin-details-heading">{cryptoDetails.name} Value Statistics</Title>
            <p>An overview showing the statistics of {cryptoDetails.name}, such as the base and quote currency, the rank, and trading volume.</p>
          </Col>
          {stats.map(({ icon, title, value }) => (
            <Col className="coin-stats">
              <Col className="coin-stats-name">
                <Text>{icon}</Text>
                <Text>{title}</Text>
              </Col>
              <Text className="stats">{value}</Text>
            </Col>
          ))}
        </Col>
        <Col className="other-stats-info">
          <Col className="coin-value-statistics-heading">
            <Title level={3} className="coin-details-heading">Other Stats Info</Title>
            <p>An overview showing the statistics of {cryptoDetails.name}, such as the base and quote currency, the rank, and trading volume.</p>
          </Col>
          {genericStats.map(({ icon, title, value }) => (
            <Col className="coin-stats">
              <Col className="coin-stats-name">
                <Text>{icon}</Text>
                <Text>{title}</Text>
              </Col>
              <Text className="stats">{value}</Text>
            </Col>
          ))}
        </Col>
      </Col>
      <Col className="coin-desc-link">
        <Row className="coin-desc">
          <Title level={3} className="coin-details-heading">What is {cryptoDetails.name}?</Title>
          {HTMLReactParser(cryptoDetails.description)}
        </Row>
        <Col className="coin-links">
          <Title level={3} className="coin-details-heading">{cryptoDetails.name} Links</Title>
          {cryptoDetails.links?.map((link) => (
            <Row className="coin-link" key={link.name}>
              <Title level={5} className="link-name">{link.type}</Title>
              <a href={link.url} target="_blank" rel="noreferrer">{link.name}</a>
            </Row>
          ))}
        </Col>
      </Col>
    </Col>
  );
};

export default CryptoDetails;